// @ts-ignore
import * as React from "react";
import { WelcomeEntryPoint } from "../entrypoints/welcome";
import { LANG } from "../common/types/localization";

export default () => <WelcomeEntryPoint lang={LANG.deCH} />;
